import { Account } from 'views/profile';
import { Profile } from 'views/profile/profile';
import { Password } from 'views/profile/password';
import { TwoFA } from 'views/profile/2fa';

const Routes = [
  {
    path: '/profile/index',
    view: Account,
    layout: 'app',
    permission: 'user',
    title: 'Profile'
  },
  {
    path: '/profile/profile',
    view: Profile,
    layout: 'app',
    permission: 'user',
    title: 'Your Info'
  },
  {
    path: '/profile/password',
    view: Password,
    layout: 'app',
    permission: 'user',
    title: 'Change Password'
  },
  {
    path: '/profile/mfa',
    view: TwoFA,
    layout: 'app',
    permission: 'user',
    title: 'Manage MFA'
  }
]

export default Routes;